import { render, staticRenderFns } from "./PromotionEdit.vue?vue&type=template&id=b3f61cf4&scoped=true"
import script from "./PromotionEdit.vue?vue&type=script&lang=js"
export * from "./PromotionEdit.vue?vue&type=script&lang=js"
import style0 from "./PromotionEdit.vue?vue&type=style&index=0&id=b3f61cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f61cf4",
  null
  
)

export default component.exports